import React from 'react';
import type { Feature, MediaItemValue } from '@fulcrumapp/fulcrum-core';
import PhotoMapView from '../photo-map-view';
import PhotoArcGisMapView from '../photo-arcgis-map-view';
import PhotoMetadataView from '../photo-metadata-view';
import type { MediaDisplayer, Metadata } from './media-displayer';
import configuredPhotoView from './configured-photo-view';
import PhotoThumbnail from './photo-thumbnail';

const photoDisplayer: MediaDisplayer = {
  display: configuredPhotoView,
  thumbnail(
    item: MediaItemValue,
    onClick: (item: MediaItemValue) => void,
    extraStyles: React.CSSProperties,
  ): React.ReactElement {
    return (
      <PhotoThumbnail
        item={item}
        styles={extraStyles}
        handleClick={() => onClick(item)}
      />
    );
  },
  mapView(
    item: MediaItemValue,
    metadata: Metadata,
    cssClass: string,
    feature?: Feature,
    visible?: boolean,
    _trackInfo?: any,
    useEsriMap?: boolean,
  ): React.ReactElement {
    if (useEsriMap) {
      return (
        <PhotoArcGisMapView
          className={cssClass}
          feature={feature}
          metadata={metadata}
          visible={visible}
        />
      );
    }
    return (
      <PhotoMapView
        className={cssClass}
        item={item}
        feature={feature}
        metadata={metadata}
        visible={visible}
      />
    );
  },
  metadata(item: MediaItemValue, metadata: Metadata, cssClass: string, feature?: Feature): React.ReactElement {
    return (
      <PhotoMetadataView
        className={cssClass}
        item={item}
        feature={feature}
        metadata={metadata}
      />
    );
  },
};

export default photoDisplayer;
